/**
 * Componente que muestra un mensaje de acceso denegado cuando el dominio no está autorizado.
 * Se renderiza cuando la validación de dominio falla en el sistema de seguridad del widget.
 * Solo permite dominios de clarosports.com, unotv.com y localhost para desarrollo.
 * 
 * @component
 * @returns {JSX.Element} Mensaje de error de autorización para dominios no permitidos
 * 
 * @example
 * // Uso típico basado en validación de dominio
 * {!isDomainAllowed && <Unauthorized />}
 */
export default function Unauthorized() {
  return (
    <div id="modalForbbiden" className="forbbiden">
      <h1>Sitio no autorizado</h1>
    </div>
  )
};